import { useEffect, useState } from 'react';
import { t } from 'services/i18n.service';
import { useAppDispatch } from 'store/hooks';
import { updateFocusTemplateMarketPlaceRequestStatus } from 'store/reducer/focus-mode/extra';
import { copyFocusTemplateLink } from 'utils/helpers';
import { FocusModeTemplateType } from 'interfaces/common.interface';
import { MarketplaceRequestStatus } from 'enums';
import { toast } from 'react-toastify';
import { MODAL_TYPES } from 'constants/general';
import { updateConfirmActionModal } from 'store/reducer/modal/slice';

export default function FocusTemplateMarketplaceControls({
  focusTemplate
}: {
  readonly focusTemplate: FocusModeTemplateType;
}) {
  const dispatch = useAppDispatch();
  const [action, setAction] = useState({
    info: '',
    button: ''
  });

  const approvalNotRequested =
    focusTemplate.marketplace_request ===
      MarketplaceRequestStatus.UNREQUESTED ||
    focusTemplate.marketplace_request === null;

  useEffect(() => {
    let updateAction = {
      info: t('focus_mode.pre_request_text'),
      button: t('packs.btn_publish')
    };

    if (focusTemplate.marketplace_approval_status) {
      updateAction = {
        info: t('focus_mode.remove_text'),
        button: t('packs.btn_remove')
      };
    }

    if (
      focusTemplate.marketplace_request === MarketplaceRequestStatus.REQUESTED
    ) {
      updateAction = {
        info: t('focus_mode.post_request_text'),
        button: t('packs.btn_cancel_request')
      };
      return;
    }
    setAction(updateAction);
  }, [focusTemplate, approvalNotRequested]);

  const handleMarketplaceRequestAction = () => {
    if (focusTemplate.marketplace_approval_status) {
      dispatch(
        updateConfirmActionModal({
          modalType: MODAL_TYPES.CONFIRM_ACTION_DELETE_FOCUS_TEMPLATE,
          confirmTitle: t('packs.btn_remove'),
          showConfirmModal: true
        })
      );
    } else {
      dispatch(
        updateFocusTemplateMarketPlaceRequestStatus({
          focusTemplate,
          status:
            focusTemplate.marketplace_request ===
            MarketplaceRequestStatus.REQUESTED
              ? MarketplaceRequestStatus.UNREQUESTED
              : MarketplaceRequestStatus.REQUESTED
        })
      );
    }
  };

  return (
    <div className='w-[100%] flex flex-col items-center gap-y-6'>
      <p className='text-sm md:text-md w-[90%] md:w-[70%]'>{action.info}</p>
      <button
        onClick={handleMarketplaceRequestAction}
        className='w-[80%] md:w-[50%] px-2 py-1 md:px-2 md:py-1 text-xs sm:text-base rounded-xl border-2 border-blue-500 text-blue-500  font-bold hover:text-white hover:bg-blue-500'>
        {action.button}
      </button>
      <p className='w-[70%] text-sm md:text-md'>
        {t('focus_mode.share_using_link')}
      </p>
      <button
        onClick={() => {
          focusTemplate.id && copyFocusTemplateLink(focusTemplate.id);
          toast.info(t('packs.copied'), {
            position: 'bottom-center',
            theme: 'colored'
          });
        }}
        className='text-orange-500 underline'>
        {t('packs.copy_link')} 🔗
      </button>
    </div>
  );
}
